module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_resort@2x-a796c20f67b508a2f9b7dd08691a388c.webp";